import EFPicture from 'elem/compCommon/EFPicture';
import { useRouter } from 'next/router';
import { useState, useEffect } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/mm100/h5/');

export default function Comp({}: any) {
    const { locale } = useRouter();
    const { useLang } = useGlobal();
    let controller: any;
    const [isEnter, setIsEnter] = useState(false);
    const { t } = useLang('ecoflowpowerkitsseries');

    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.kitA',
            offset: 0, //从开始点滚动多少px触发,可为负数
            triggerHook: 0.6, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '100%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        sceneA1.on('enter', function () {
            setIsEnter(true);
        });

        controller.addScene(sceneA1);
    }, []);

    return (
        <div className={`${css.kitA} kitA`}>
            <div className="img-content">
                {locale === 'au' ? (
                    <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1722827982001/efmm100bg_au_h5.jpg" alt={t('presale.product.kitA_title1')} />
                ) : (
                    <EFPic name={['efmm100bg.webp', 'efmm100bg.jpg']} className="fullImgs" alt="" />
                )}
            </div>
            <div className={`v-msg ${isEnter ? 'isEnter' : ''}`}>
                <div className="v-msg-title1">{t('presale.product.kitA_title1')}</div>
                <div className="v-msg-title2">{t('presale.product.kitA_title2')}</div>
            </div>
        </div>
    );
}
